import { Component, Inject, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';

import { APP_SEARCH_SERVICE_TOKEN } from './app-search-config';

import { IAppSearchService } from './app-search.service';

import { SearchResult } from './app-search.models';

@Component({
  selector: 'sca-app-search',
  templateUrl: './app-search.component.html',
  styleUrls: ['./app-search.component.scss']
})
export class AppSearchComponent implements OnDestroy {
  private _searchSubscription: Subscription = new Subscription();

  public searchResults: SearchResult[] = [];
  public searchText: string = '';

  public isLoading: boolean = false;
  public resultResultMessage: string = '';

  constructor(@Inject(APP_SEARCH_SERVICE_TOKEN) private _appSearchService: IAppSearchService) {}

  ngOnDestroy(): void {
    this._searchSubscription.unsubscribe();
  }

  public onEnterKeyDownEvent(event: any) {
    this.searchText = event.target.value;

    if (this.searchText === '') {
      return;
    }

    this.isLoading = true;
    this.resultResultMessage = '';

    this._searchSubscription = this._appSearchService.search(this.searchText).subscribe({
      next: (results: SearchResult[]) => {
        this.searchResults = results;
        this.resultResultMessage = this.searchResults.length > 0 ? '' : 'No Results Found';
      },
      complete: () => {
        this.isLoading = false;
      }
    });
  }

  public onOptionSelected(event: any, searchResult: SearchResult): void {
    if (event.isUserInput) {
      this._appSearchService.redirectTo(searchResult);

      this.searchResults = [];
      this.searchText = '';
    }
  }

  public clearSearch(): void {
    this.searchResults = [];
    this.searchText = '';
  }
}


